export {};
//# sourceMappingURL=type-discriminator-descriptor.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/decorator-options/type-discriminator-descriptor.interface.js
// module id = 793
// module chunks = 3